import { SortDirectionEnum } from '../../legacy/shared-types';
import { IProductDataTransformed } from 'queries/products/useProductsList/types';
import {
  AllFiltersTypes,
  ALL_FILTER_OPTION,
  IProductFilters,
  TableColumns,
} from 'pages/ProductsPage/ProductsTable/types';

export const useProductSortAndFilters = (
  order: SortDirectionEnum,
  orderBy: TableColumns,
  searchedValue: string,
  filtersState: IProductFilters,
) => {
  const sortStrings = (a: IProductDataTransformed, b: IProductDataTransformed) => {
    const isAsc = order === SortDirectionEnum.ASC;
    const valueA = String(a[orderBy]).toUpperCase();
    const valueB = String(b[orderBy]).toUpperCase();

    if (valueA < valueB) return isAsc ? -1 : 1;
    if (valueA > valueB) return isAsc ? 1 : -1;
    return 0;
  };

  const sortNumbers = (a: IProductDataTransformed, b: IProductDataTransformed) => {
    const isAsc = order === SortDirectionEnum.ASC;
    const valueA = Number(a[orderBy]);
    const valueB = Number(b[orderBy]);

    if (valueA < valueB) return isAsc ? -1 : 1;
    if (valueA > valueB) return isAsc ? 1 : -1;
    return 0;
  };

  const sortByColumnValue = (a: IProductDataTransformed, b: IProductDataTransformed) => {
    if (typeof a[orderBy] === 'string') return sortStrings(a, b);
    if (typeof a[orderBy] === 'number') return sortNumbers(a, b);
    return 0;
  };

  const sortByActiveStateDesc = (a: IProductDataTransformed, b: IProductDataTransformed) => {
    const valueA = a.isActive;
    const valueB = b.isActive;

    if (valueA < valueB) return 1;
    if (valueA > valueB) return -1;
    return 0;
  };

  const isProductContainsSearchValue = (row: IProductDataTransformed) =>
    row.code.toString().includes(searchedValue.trim()) ||
    row.description.toLowerCase().trim().includes(searchedValue.toLowerCase().trim());

  const isFilterOff = (filter: AllFiltersTypes) => !filter || filter === ALL_FILTER_OPTION;

  const filterByAllFilters = (productList: IProductDataTransformed[]) =>
    productList.filter(product => {
      const {
        ftv,
        productType: filterProductType,
        isActiveProductsOnly,
        productRange: filterProductRange,
        productCategory: filterProductCategory,
      } = filtersState;
      const { maximumFTV, productType, isActive, productRange, productCategory } = product;

      const isProductFitsProductCategoryFilter =
        isFilterOff(filterProductCategory) || productCategory === filterProductCategory;
      const isProductFitsFTVFilter = isFilterOff(ftv) || maximumFTV === Number(ftv);
      const isProductFitsProductTypeFilter = isFilterOff(filterProductType) || productType === filterProductType;
      const isProductFitsIsActiveFilter = !isActiveProductsOnly || isActive;
      const isProductFitsProductRangeFilter = isFilterOff(filterProductRange) || productRange === filterProductRange;
      const isProductFitsSearchFilter = isProductContainsSearchValue(product);

      return (
        isProductFitsProductCategoryFilter &&
        isProductFitsFTVFilter &&
        isProductFitsProductTypeFilter &&
        isProductFitsIsActiveFilter &&
        isProductFitsProductRangeFilter &&
        isProductFitsSearchFilter
      );
    });

  const filterHandler = (productList: IProductDataTransformed[]) =>
    filterByAllFilters(productList).sort(sortByColumnValue).sort(sortByActiveStateDesc);

  return filterHandler;
};
